module.exports = __webpack_public_path__ + "img/out.4688c8a7.png";